import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateCarrierResponsibleEmailActions } from "store/ducks/settings/carrier-responsible-email";

export function* createCarrierResponsibleEmailRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/carrier-responsible-email`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateCarrierResponsibleEmailActions.success(data));
    notify("success", "E-mail responsável salvo com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateCarrierResponsibleEmailActions.failure(errorMessage));
  }
}
